import { refreshAvailabilityData } from './auto-refresh'
import Spektrix from './classes/Spektrix'
import helpers from './helpers'

function displayBookingError ($bookingForm, errorMessage) {
  const $wrapper = $bookingForm.closest('li')

  $wrapper.append(`
    <strong class="c-notice c-notice_error" role="alert">
      <i class="fa fa-times-circle c-notice__icon" aria-hidden="true"></i>
      <span class="c-notice__content">Error: ${errorMessage}</span>
      <button type="button" class="c-btn c-notice__close-btn" onclick="this.closest('strong').remove()">
        <i class="fa fa-times" aria-hidden="true"></i>
        <span class="u-hidden-visually">Hide this error</span>
      </button>
    </strong>
  `)

  $wrapper.find('.c-notice_error')[0].scrollIntoViewIfNeeded()
}

function clearBookingFormErrors ($bookingForm) {
  $bookingForm.closest('li').find('.c-notice_error').remove()
}

jQuery(document).ready(function () {
  const spektrix = new Spektrix()

  // Sessions for the by opera page master filters
  const setSession = function (key, value) {
    sessionStorage.setItem(key, value)
  }

  const getSession = function (key) {
    return sessionStorage.getItem(key)
  }

  const deleteSession = function (key) {
    sessionStorage.removeItem(key)
  }

  // Reset select states on refresh
  $('select').prop('selectedIndex', 0)

  /* submit & clear filters button */

  // When apply buttons is clicked
  $('#c-btn-submit--dropdowns').on('click', function () {
    const venue = $('#header-controls select[name=venue]').val()
    const quantity = $('#header-controls select[name=quantity]').val()
    const section = $('#header-controls select[name=section]').val()
    const priceBand = $('#header-controls select[name=price_band]').val()

    if (venue !== 'none' || quantity !== 'none' || section !== 'none' || priceBand !== 'none') {
      setSession('venue', venue)
      setSession('quantity', quantity)
      setSession('section', section)
      setSession('price_band', priceBand)

      $('#c-btn-clear--dropdowns').removeClass('hidden')

      initFilters()
    }
  })

  // When clear button is clicked
  $('#c-btn-clear--dropdowns').on('click', function () {
    // Delete the sessions
    deleteSession('venue')
    deleteSession('quantity')
    deleteSession('section')
    deleteSession('price_band')

    // Set dropdowns to 'none'
    $('select[name=venue]').val('none')
    $('select[name=quantity]').val('none')
    $('select[name=section]').val('none')
    $('select[name=price_band]').val('none')

    if ($venueSelect.find('option').length === 1) {
      $venueSelect.val($venueSelect.find('option').val())
    }

    $('#header-controls select[name=section] > option').slice(1).hide()

    $('#c-btn-clear--dropdowns').addClass('hidden')
    initFilters()
  })

  $('select[name=section]').on('change', function () {
    if ($(this).val() === 'none') {
      $(this).parents('.booking-form').find('select[name=price_band]').prop('disabled', true)
    } else {
      $(this).parents('.booking-form').find('select[name=price_band]').removeAttr('disabled')
    }
  })

  const $venueSelect = $('select[name=venue]');
  $venueSelect.on('change', function () {
    /* Master form controls */
    const venue = $('#header-controls select[name=venue]').val()
    // Hide the option in position 1
    $('#header-controls select[name=section] > option').slice(1).hide()
    // Show the sections applicable to each section
    $('#header-controls select[name=section] > option').each(function () {
      if (venue === $(this).data('venue')) {
        $(this).show()
      }
    })
    // Reset other inputs from the master filters
    $("#header-controls select:not([name='venue'])").val('none').trigger('change')
  })

  // Auto-trigger the change event on the venue on page load if there's just one option that is auto-selected
  if ($venueSelect.find('option').length === 1) {
    $venueSelect.trigger('change')
  }

  /**
   * Toggles the submit button.
   * This field is only unlocked when _all_ other fields are not "none".
   *
   * @param {string} currentForm The identifier for the current form.
   */
  const toggleButton = function (currentForm = '') {
    const elements = {
      'quantity': $(currentForm + ' select[name=quantity]'),
      'section': $(currentForm + ' select[name=section]'),
      'priceBand': $(currentForm + ' select[name=price_band]'),
      'submit': $(currentForm + ' input[type=submit]')
    }

    if (elements.quantity.val() !== 'none' && (elements.section.val() !== 'none' || elements.priceBand.val() !== 'none')) {
      elements.submit.prop('disabled', false)
    } else {
      elements.submit.prop('disabled', true)
    }
  }

  const updateSection = function (_this) {
    const instanceID = $(_this).parents('.booking-form').data('id')

    if (!instanceID) {
      return
    }

    const sectionID = $(_this).val()
    const currentForm = '.booking-form[data-id=' + instanceID + ']'
    const $priceBandsSelect = $(currentForm + ' select[name=price_band]')
    const areas = priceBandData.price_band_mappings[instanceID] || {}
    const priceBands = areas[sectionID] || []
    const previouslySelectedOption = $priceBandsSelect.val()
    let previousOptionReSelected = false
    let optionsHtml = ''

    // Sort priceBands by numeric value (after stripping £ and converting to float)
    priceBands.sort((a, b) => {
      const valA = parseFloat(a.value.replace(/[£,]/g, ''))
      const valB = parseFloat(b.value.replace(/[£,]/g, ''))
      return valA - valB
    })

    for (const priceBand of priceBands) {
      const wasPreviouslySelected = priceBand.ID === previouslySelectedOption
      optionsHtml = `
        <option
            value="${priceBand.ID}" ${wasPreviouslySelected ? 'selected' : ''}
            data-price-band="${priceBand.priceBand}"
            data-ticket-type="${priceBand.ticketType}">
            ${priceBand.value} - ${priceBand.name} (${priceBand.count})
        </option>` + optionsHtml

      if (wasPreviouslySelected) {
        previousOptionReSelected = true
      }
    }

    optionsHtml = `<option value="none" ${previousOptionReSelected ? '' : 'selected'}>Select price band</option>` + optionsHtml
    $priceBandsSelect.html(optionsHtml)

    toggleButton(currentForm)
  }

  /* Updates the `Price Band` select box based on the `Section` selected. */
  $('#header-controls select[name=section]').on('change', function () {
    $.ajax({
      url: appURL + '/ajax/update-masterpriceband',
      method: 'post',
      dataType: 'json',
      data: {
        'venue': $('#header-controls select[name=venue]').val(),
        'section': $(this).val()
      },
      success: function (result) {
        const $priceBandSelect = $('#header-controls select[name=price_band]')
        const previouslySelectedOption = $priceBandSelect.val()
        let previousOptionReSelected = false
        let optionsHtml = ``

        for (const priceBand of result.data) {
          const value = `${priceBand.value} - ${priceBand.name}`
          const wasPreviouslySelected = value === previouslySelectedOption
          optionsHtml = `<option value="${value}" ${wasPreviouslySelected ? 'selected' : ''}>${value}</option>` + optionsHtml

          if (wasPreviouslySelected) {
            previousOptionReSelected = true
          }
        }

        optionsHtml = `<option value="none" ${previousOptionReSelected ? '' : 'selected'}>Select price band</option>` + optionsHtml

        $('#header-controls select[name=price_band]').html(optionsHtml)
      }
    })
  })

  /* Updates the `Price Band` select box based on the `Section` selected. */
  $('.c-page-events-list__item select[name=section]').on('change', function () {
    updateSection(this)
  })

  /* populate the price dropdown */

  const togglePriceBand = function (value) {
    const trimmedValue = $.trim(value)

    $('select[name=price_band]').each(function (index) {
      $(this).children('option').attr('selected', false)
      $(this).children('option:not(option[disabled])').each(function (index) {
        const label = $(this).text().trim()
        const labelWithoutQuantity = label.substring(0, label.lastIndexOf(' '))

        if (trimmedValue === labelWithoutQuantity) {
          $(this).closest('select').val(this.value)
        }
      })
    })
  }

  /* collect the data for the sections drop down by venue */

  const populateQuantityDropdowns = function (value) {
    $('select[name=quantity]').each(function (index) {
      $(this).val(value)
      const instanceID = $(this).parents('.booking-form').data('id')
      const currentForm = '.booking-form[data-id=' + instanceID + ']'
      togglePriceBand($('#header-controls select[name=price_band]').val())
      toggleButton(currentForm)
    })
  }

  /**
   * Loops through the instance section dropdowns and populates them with the master dropdown value.
   * @return void
   */
  const populateSectionDropdowns = function (area) {
    $('select[name=section]').each(function (index) {
      $(this).children('option').attr('selected', false)
      $(this).children('option:not(option[disabled])').each(function (index) {
        if ($.trim($(this).text()) === $.trim(area)) {
          $(this).closest('select').val(this.value).trigger('change')
        }
      })
      updateSection(this)
    })
  }

  /**
   * Loops through the events by the .c-page-events-list__item class
   * & if the venue in .c-page-events-body__venue does not match the chosen
   * venue hide the event.
   * @return void
   */
  const filterEvents = function (venue) {
    $('.c-event-list__item').each(function () {
      const $instances = $(this).find('.c-page-events-list__item')
      let hiddenCount = 0

      $instances.each(function (index) {
        const itemVenue = $.trim($(this).find('.c-page-events-body__venue').text())
        if (venue !== itemVenue && venue !== 'none') {
          $(this).hide()
          hiddenCount += 1
        } else {
          $(this).show()
        }
      })

      $(this).toggle(hiddenCount !== $instances.length)
    })
  }

  /**
   * Populates the instance dropdowns & filters instances by venue
   * @return void
   */
  const initFilters = function () {
    populateQuantityDropdowns($('#header-controls select[name=quantity]').val())
    populateSectionDropdowns($('#header-controls select[name=section]').val())
    togglePriceBand($('#header-controls select[name=price_band]').val())
    filterEvents($('#header-controls select[name=venue]').val())
  }

  /**
   * Checks to see if the dropdowns have been selected and saved in a session.
   * If set, sets the value to the session value and runs initFilters()
   * @return void
   */
  const checkSessions = function () {
    const venue = getSession('venue')
    const quantity = getSession('quantity')
    const section = getSession('section')
    const priceBand = getSession('price_band')
    if (venue) { $('#header-controls select[name=venue]').val(venue).trigger('change') }
    if (quantity) { $('#header-controls select[name=quantity]').val(quantity).trigger('change') }
    if (section) { $('#header-controls select[name=section]').val(section).trigger('change') }
    if (priceBand) { $('#header-controls select[name=price_band]').val(priceBand).trigger('change') }
    if (venue || quantity || section || priceBand) {
      $('#c-btn-clear--dropdowns').removeClass('hidden')
    }
    initFilters()
  }
  checkSessions()

  /**
   * Fire on change of the instance quantity drop down.
   * @return void
   */
  $('select[name=quantity]').on('change', function () {
    const instanceID = $(this).parents('.booking-form').data('id')
    const currentForm = '.booking-form[data-id=' + instanceID + ']'
    toggleButton(currentForm)
  })

  $('.booking-form').on('submit', function (e) {
    e.preventDefault()

    const submitButton = this.querySelector('[type=submit]')
    const instanceID = $(this).data('id')
    const currentForm = '.booking-form[data-id=' + instanceID + ']'
    const $bookingForm = $(currentForm)
    const originalButtonLabel = submitButton.value
    const sectionID = $(currentForm + ' select[name=section]').val()
    const quantity = $(currentForm + ' select[name=quantity]').val()
    const payload = {
      instance: instanceID,
      quantity: quantity
    }

    clearBookingFormErrors($bookingForm)

    if (sectionID !== 'none' && sectionID) {
      payload.seatingAreas = [sectionID]
    }

    const priceBands = $(currentForm + ' select[name=price_band] option:selected').data('price-band')
    if (priceBands) {
      payload.priceBands = [priceBands]
    }

    // Check local availability data before making the request to Spektrix
    for (const priceBandAvailability of priceBandData.price_band_mappings[instanceID][sectionID]) {
      if (priceBandAvailability.priceBand === priceBands) {
        if (priceBandAvailability.count < quantity) {
          displayBookingError($bookingForm, `
            There are only ${priceBandAvailability.count} seats left for this selection. Please review your selection and try again.
          `)
          return
        }

        break
      }
    }

    const instanceSelect = $(this).closest('.c-page-events-list__item').find('.instance-expand')
    instanceSelect.toggleClass('active')
    instanceSelect.html(helpers.loadingButton('dark'))

    submitButton.disabled = true
    submitButton.value = 'Submitting...'

    spektrix.post('basket/tickets/best-available', { body: payload })
      .then((response) => {
        if (response.ok) {
          $('.c-loading').show()
          window.BASKET.refresh()
          instanceSelect.html('Selected')
          $(this).closest('.c-page-events-list__item').find('.booking-form').slideToggle()
        } else {
          instanceSelect.html('Select <i class="fa fa-chevron-down" aria-hidden="true"></i>')
          refreshAvailabilityData()
          displayBookingError($bookingForm, `
            Oops, something went wrong...<br><br>
            Unfortunately in order to create this package you will need to call our box office team directly on 0113 223 3600, or <a href="https://www.operanorth.co.uk/contact-us/" title="Contact the Opera North box office" target="_blank">contact us online</a>
          `)
        }
      }).finally(() => {
        submitButton.disabled = false
        submitButton.value = originalButtonLabel
      })
  })
})

/**
     * Toggles the filters.
     */

$('.c-event-filter__dropdown-trigger').click(function () {
  $('body').addClass('state--has-dropdown')
  $('.c-event-filter__dropdown').addClass('active')
})
$('.c-event-filter__overlay, .c-event-filter__dropdown.active .c-event-filter__dropdown-trigger').click(function () {
  $('body').removeClass('state--has-dropdown')
  $('.c-event-filter__dropdown').removeClass('active')
})



// WEBPACK FOOTER //
// ./resources/assets/js/booking-form.js